import { PolicyData } from "./policy-data"

export class PasswordPolicy extends PolicyData {
    public get PoolId(): string {
        return this.poolId
    }
    constructor(
        private poolId: string,
        private minimumPasswordLength: number,
        private requireUppercaseCharacters: boolean,
        private requireLowercaseCharacters: boolean,
        private requireNumberValues: boolean,
        private requireSymbolCharacters: boolean,
    ) {
        super(
            minimumPasswordLength,
            requireUppercaseCharacters,
            requireLowercaseCharacters,
            requireNumberValues,
            requireSymbolCharacters
        )
    }

    public static create(poolId: string, policyData: PolicyData): PasswordPolicy {
        return new PasswordPolicy(
            poolId,
            policyData?.MinimumLength,
            policyData?.RequireUppercase,
            policyData?.RequireLowercase,
            policyData?.RequireNumbers,
            policyData?.RequireSymbols
        )
    }

}